var caseStudyStickyBar = (function () {
  function init() {
    uiBindings();
  }

  var uiBindings = function () {
    var csHideFloatingBanner = Cookie.read('csHideFloatingBanner'),
      caseStudyStickyBar = document.getElementById('case-study-sticky-bar');

    if (window.innerWidth > 979) {
      if (caseStudyStickyBar) {
        caseStudyStickyBar.remove();
      }
    }

    if (!csHideFloatingBanner || csHideFloatingBanner === 'null' || csHideFloatingBanner === 'undefined') {
      var singleCaseStudy = document.querySelector('.single-case_study'),
        headerHabitat = document.getElementById('header-habitat'),
        headerHeight = headerHabitat ? headerHabitat.offsetHeight : 0,
        stickyBarHeight = caseStudyStickyBar ? caseStudyStickyBar.offsetHeight : 0,
        bottomScrollHeight = document.getElementById('footer-habitat').offsetTop,
        lastScrollTop = 0,
        primaryMenuToggle = document.getElementById('primary-menu-toggle'),
        close = document.getElementById('close-case-study-sticky-bar');

      if (singleCaseStudy && caseStudyStickyBar) {
        caseStudyStickyBar.style.display = 'block';
        if (headerHabitat && (window.pageYOffset === 0 || document.documentElement.scrollTop === 0)) {
          caseStudyStickyBar.style.top = '0px';
          caseStudyStickyBar.style.position = 'relative';
        }

        window.addEventListener('scroll', function () {
          var currentTop = window.pageYOffset || document.documentElement.scrollTop;

          if (currentTop > lastScrollTop) {
            caseStudyStickyBar.style.position = 'fixed';
            caseStudyStickyBar.style.top = '0px';
          } else {
            if (primaryMenuToggle && primaryMenuToggle.classList.contains('active') && currentTop !== 0) {
              caseStudyStickyBar.style.position = 'fixed';
              caseStudyStickyBar.style.top = '0px';
            } else if (currentTop === 0) {
              caseStudyStickyBar.style.position = 'relative';
              caseStudyStickyBar.style.top = '0px';
            } else {
              caseStudyStickyBar.style.position = 'fixed';
              caseStudyStickyBar.style.top = headerHeight + 'px';
            }
          }
          lastScrollTop = currentTop;
          if (currentTop + stickyBarHeight > bottomScrollHeight) {
            caseStudyStickyBar.style.display = 'none';
          } else {
            caseStudyStickyBar.style.display = 'block';
          }
        });
        if (close) {
          document.getElementById('close-case-study-sticky-bar').addEventListener('click', function () {
            var d = new Date();
            d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
            document.cookie = 'csHideFloatingBanner=1;expires=' + d.toUTCString() + ';path=' + window.location.pathname;
            caseStudyStickyBar.remove();
          });
        }
      }
    } else {
      if (caseStudyStickyBar) {
        caseStudyStickyBar.remove();
      }
    }
  };

  init();
})();
